import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import './applicationTableTravelHistory.scss' 


const  ApplicationTableTravelHistoryInfo = ({ applicationData}) => {


  
const downloadImage = (url, defaultName = "document") => {
  if (!url) return;

  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      // 1. Detect the file extension automatically from the blob type
      let extension = "jpg"; // fallback extension
      
      if (blob.type === "application/pdf") {
        extension = "pdf";
      } else if (blob.type === "image/png") {
        extension = "png";
      } else if (blob.type === "image/jpeg" || blob.type === "image/jpg") {
        extension = "jpg";
      }

      // 2. Clean the provided file name so it doesn't have a duplicated or wrong extension
      const baseName = defaultName.split('.')[0];
      const finalFileName = `${baseName}.${extension}`;

      // 3. Create the object URL and trigger the native download
      const blobUrl = window.URL.createObjectURL(blob); 
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = finalFileName;
      
      document.body.appendChild(link);
      link.click();

      // 4. Memory Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => {
      console.error("Download failed:", error);
    });
};  
                                   
 

  return (
            
    <div className=''>

        {
            applicationData.travelledBefore === "travelled"

            ?

            
            <div className='item'>
                <div className='details'>
                <div className='detailItem'>
                    <span className='itemKey'>Have You Travelled Before:</span>
                    <span className='itemValue'>Yes</span>
                </div>
                </div>
            </div>
         

            :
            <div className='item'>
                <div className='details'>

                <div className='detailItem'>
                    <span className='itemKey'>Have You Travelled Before:</span>
                    <span className='itemValue'>No</span>
                </div>
                </div>
            </div>

        }

        {
            applicationData.haveRelative === "haveRelative"

            ?
            
            <div className='item'>

            <div className="details">

                <div className='detailItem'>
                    <span className='itemKey'>Do you have Relative:</span>
                    <span className='itemValue'>Yes</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Relative name:</span>
                    <span className='itemValue'>{applicationData.relativeName}</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Relative Address:</span>
                    <span className='itemValue'>{applicationData.relativeAddress}</span>
                </div>
         
            </div>
            </div>

            :
            ""

        }

        {
            applicationData.refused === "refused"

            ?
            <div className='item'>
            <div className="details">

                <div className='detailItem'>
                    <span className='itemKey'>Have you been refused visa Before?:</span>
                    <span className='itemValue'>Yes</span>
                </div>
                <div className='detailItem'>
                    <span className='itemKey'>Decision Letter:</span>
                    
                  <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.decisionLetterImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.decisionLetterImage, "decisionLetterImage")}
                    style={{ background: 'none', border: 'none', color:  '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                  </div>

                </div>
             
            </div>
            </div>
            :
            ""

        }

        
    </div>
   
  );
}

export default ApplicationTableTravelHistoryInfo